import {DeliveryGroupDto} from "../../types/schedule/delivery-group-dto";
import {PreviewDeliveryGroupDto} from "../../types/schedule/preview-delivery-group-dto";
import {PreviewDeliveryInGroup} from "../../types/schedule/preview-delivery-in-group";
import {WorkPlaceDto} from "../../types/work-place/work-place-dto";
import {removeDuplication} from "../remove-duplication";

export const addressFormatByWorkPlace = (workPlace: WorkPlaceDto) => {
    return `${workPlace.alias} ${workPlace.detail}`;
};

export const addressFormatByInProgressWorkPlace = (
    deliveries: PreviewDeliveryInGroup[]
) => {
    const inProgressWorkPlaceList = deliveries.map(
        (delivery) =>
            `${delivery.inProgressWorkPlace.alias} ${delivery.inProgressWorkPlace.detail}`
    );
    const inProgressWorkPlaceSet = removeDuplication(inProgressWorkPlaceList);
    if (inProgressWorkPlaceSet.length === 1) {
        return `${deliveries[0].inProgressWorkPlace.alias} ${deliveries[0].inProgressWorkPlace.detail}`;
    } else {
        return `${deliveries[0].inProgressWorkPlace.alias} ${
            deliveries[0].inProgressWorkPlace.detail
        } 외 ${inProgressWorkPlaceSet.length - 1}곳`;
    }
};

export const addressFormatByPairWorkPlace = (pairWorkPlace: WorkPlaceDto) => {
    return `${pairWorkPlace.alias} ${pairWorkPlace.detail}`;
};

export const addressFormatByDeliveryGroup = (
    deliveryGroup: DeliveryGroupDto | PreviewDeliveryGroupDto
) => {
    // const inProgressgroupInfos = deliveryGroup.detailInfos.map(
    //   (deliveryGroup) => deliveryGroup.inProgressGroupInfo
    // );
    const inProgressWorkPlaceList = deliveryGroup.deliveriesInGroup.map(
        (delivery) =>
            `${delivery.inProgressWorkPlace.alias} ${delivery.inProgressWorkPlace.detail.replace("$회수$", "[회수] ")}`
    );
    const inProgressWorkPlaceSet = removeDuplication(inProgressWorkPlaceList);

    if (inProgressWorkPlaceSet.length === 0) {
        return "";
    }

    if (inProgressWorkPlaceSet.length === 1) {
        // 단건일 때
        if (deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.name === null) {
            // 상호 없을 때
            return `${deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.alias} ${deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.detail.replace("$회수$", "[회수] ")}`;
        } else {
            // 상호 있을 때
            return `${deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.detail.replace("$회수$", "[회수] ")} ${deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.alias}`;
        }
    } else {
        // 다건일 때
        if (deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.name === null) {
            // 상호 없을 때
            return `${deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.alias} ${
                deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.detail.replace("$회수$", "[회수] ")
            } 외 ${inProgressWorkPlaceSet.length - 1}곳`;
        } else {
            // 상호 있을 때
            return `${
                deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.detail.replace("$회수$", "[회수] ")
            } ${deliveryGroup.deliveriesInGroup[0].inProgressWorkPlace.alias}  외 ${
                inProgressWorkPlaceSet.length - 1
            }곳`;
        }
    }
};
